module.exports = __webpack_public_path__ + "media/images/icons/flags/GN-88a93da25c318b46477a12d5c0eae1bd.svg";